
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.5998 18.2L12.9998 11.75V10.84C14.6498 10.35 15.7998 8.67001 15.4298 6.79001C15.1698 5.48001 14.1298 4.39001 12.8198 4.09001C11.0598 3.69001 9.44977 4.62001 8.79977 6.07001C8.49977 6.74001 8.97977 7.50001 9.70977 7.50001C10.0998 7.50001 10.4598 7.28001 10.6098 6.93001C10.8398 6.38001 11.3698 6.00001 11.9998 6.00001C12.8298 6.00001 13.4998 6.67001 13.4998 7.50001C13.4998 8.34001 12.8098 9.02001 11.9698 9.00001C11.4298 8.99001 10.9998 9.45001 10.9998 9.99001V11.75L2.39977 18.2C1.62977 18.78 2.03977 20 2.99977 20H11.9998H20.9998C21.9598 20 22.3698 18.78 21.5998 18.2ZM5.99977 18L11.9998 13.5L17.9998 18H5.99977Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-checkroom`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconCheckroom

    ```js
    <b-new-b-icon-checkroom />
    ```
</docs>


